import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
    acceptText: _ctx.acceptText,
    "accept-theme": "primary",
    "reject-theme": "return",
    "full-screen": true,
    image: _ctx.attachedTrailerCompany,
    forceHideDeepLink: _ctx.showDeepLink,
    rejectText: _ctx.rejectText,
    "title-text": `<b>We show you are currently loaded.</b>`,
    "subheading-text": _ctx.subheadingText,
    "subtitle-text": _ctx.subtitleText,
    "subtitle-style": "strong-subtitle",
    onAccept: _ctx.acceptAction,
    onReject: _ctx.rejectAction
  }, null, 8, ["acceptText", "image", "forceHideDeepLink", "rejectText", "title-text", "subheading-text", "subtitle-text", "onAccept", "onReject"]))
}